import fromPairs from 'ramda/es/fromPairs';
import isArray from './helpers/isArray';
import isObject from './helpers/isObject';
import trimTrailingSlash from './helpers/trimTrailingSlash';
import {SERVICE_DEFAULT} from './config';

// backwards compatibility as many call sites wrap configuration
const unwrapApiPath = apiCfg =>
  isObject(apiCfg?.apiPath) ? apiCfg.apiPath : apiCfg;

const getApiEndpoint = (apiPath, resource) =>
  `${trimTrailingSlash(apiPath)}${resource}`;

const toEndpoint = endpoints => {
  if (isArray(endpoints)) {
    return toEndpointFromArray(endpoints);
  } else {
    return toEndpointFromDict(endpoints);
  }
};

const toEndpointFromArray = endpoints => apiCfg =>
  fromPairs(
    endpoints.map(resource => [
      resource,
      getApiEndpoint(
        unwrapApiPath(apiCfg)[SERVICE_DEFAULT] ?? unwrapApiPath(apiCfg).apiPath,
        `/${resource}`
      )
    ])
  );

const toEndpointFromDict = endpoints => apiCfg =>
  Object.keys(endpoints)
    .map((service, _index) => {
      const unwrappedCfg = unwrapApiPath(apiCfg);
      return toEndpointFromArray(endpoints[service])({
        [SERVICE_DEFAULT]:
          unwrappedCfg[service] ?? unwrappedCfg[SERVICE_DEFAULT] ?? ''
      });
    })
    .reduce((prev, next) => Object.assign(prev, next), {});

export {toEndpoint as default, getApiEndpoint};
